import { genreOptions, regionOptions, yearOptions } from "@/mocks/media";

interface CategoryFiltersProps {
  genres: string[];
  region: string;
  year: number | null;
  sort: string;
  hasFilter: boolean;
  onToggleGenre: (g: string) => void;
  onRegion: (r: string) => void;
  onYear: (y: number) => void;
  onSort: (s: string) => void;
  onReset: () => void;
}

const sortOptions = [
  { key: "default", label: "默认" },
  { key: "date", label: "按更新时间" },
  { key: "popularity", label: "按热度" },
];

export default function CategoryFilters({
  genres,
  region,
  year,
  sort,
  hasFilter,
  onToggleGenre,
  onRegion,
  onYear,
  onSort,
  onReset,
}: CategoryFiltersProps) {
  return (
    <div className="space-y-5">
      <div>
        <h4 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wider text-foreground-400">
          类型
        </h4>
        <div className="flex flex-wrap gap-2">
          {genreOptions.map((g) => {
            const active = genres.includes(g);
            return (
              <button
                key={g}
                type="button"
                onClick={() => onToggleGenre(g)}
                className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                  active
                    ? "border-accent-500 bg-accent-500 text-background-50"
                    : "border-background-300/60 text-foreground-600 hover:border-accent-500/60 hover:text-foreground-950"
                }`}
              >
                {g}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <h4 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wider text-foreground-400">
          地区
        </h4>
        <div className="flex flex-wrap gap-2">
          {regionOptions.map((r) => {
            const active = region === r;
            return (
              <button
                key={r}
                type="button"
                onClick={() => onRegion(r)}
                className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                  active
                    ? "border-primary-400 bg-primary-500 text-foreground-950"
                    : "border-background-300/60 text-foreground-600 hover:border-primary-400/60 hover:text-foreground-950"
                }`}
              >
                {r}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <h4 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wider text-foreground-400">
          年份
        </h4>
        <div className="flex flex-wrap gap-2">
          {yearOptions.map((y) => {
            const active = year === y;
            return (
              <button
                key={y}
                type="button"
                onClick={() => onYear(y)}
                className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                  active
                    ? "border-secondary-400 bg-secondary-500 text-foreground-950"
                    : "border-background-300/60 text-foreground-600 hover:border-secondary-400/60 hover:text-foreground-950"
                }`}
              >
                {y}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <h4 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wider text-foreground-400">
          排序
        </h4>
        <div className="flex items-center rounded-full bg-background-200/70 p-1">
          {sortOptions.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onSort(s.key)}
              className={`flex-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
                sort === s.key
                  ? "bg-accent-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {hasFilter && (
        <button
          type="button"
          onClick={onReset}
          className="flex h-10 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/60 text-sm text-foreground-700 transition-colors hover:text-foreground-950"
        >
          <i className="ri-refresh-line text-base"></i>
          重置筛选
        </button>
      )}
    </div>
  );
}